var map = {
	"./Air-Conditioner.svg": "6436",
	"./Breakfast.svg": "00c1",
	"./Child-Friendly.svg": "dfd8",
	"./Great-View.svg": "5bfb",
	"./Mini-Bar.svg": "10f3",
	"./Pet-Friendly.svg": "87c9",
	"./Refrigerator.svg": "32b9",
	"./Room-Service.svg": "030b",
	"./Smoke-Free.svg": "407b",
	"./Sofa.svg": "4125",
	"./Television.svg": "986e",
	"./Wi-Fi.svg": "6c71",
	"./album-next.svg": "9e97",
	"./album-prev.svg": "8953",
	"./cancel.svg": "8f8d",
	"./compose.svg": "9b6b",
	"./fail.svg": "f1a1",
	"./list_null.svg": "3096",
	"./ok.svg": "cc84",
	"./payment.svg": "bd8a",
	"./previous.svg": "203b",
	"./search_chat.svg": "1308",
	"./success.svg": "17bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";